import { ApiTransformedAttachment } from '@fiverr-private/ai_brief';
import { Gql } from '@fiverr-private/dynamic_matching';
import { transformApiAttachmentToFileAttachment } from './transformApiAttachmentToFileAttachment';

export const transformApiAttachments = (apiAttachments: Gql.DmBrief['attachments']): ApiTransformedAttachment[] => {
    if (!apiAttachments?.length) return [];

    return apiAttachments.map(transformApiAttachmentToFileAttachment);
};
